import { render, staticRenderFns } from "./ui-menu.vue?vue&type=template&id=5d8d8d48"
import script from "./ui-menu.vue?vue&type=script&lang=js"
export * from "./ui-menu.vue?vue&type=script&lang=js"
import style0 from "./ui-menu.vue?vue&type=style&index=0&id=5d8d8d48&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports